import { api } from "../../../../api"
import { setAlertFunc } from "../../../../components/AlertToaster/AlertSlice"
import { IFile, IResponse, StatusButton, StatusTabsData, TicketDataResponseType } from "../../../Common/commonTypes"
import { getTicketDetails } from "../../../Projects/ProjectSlice"
import { getDemolition, getDemolitionTabs } from "../../OperationSlice"

const MODULE_URL = "operations"

type OpsCompletionDateObj = {
    completion_date: string
    timestamp: string
    user_id: number
    username: string
    reason?:string
}

export type CardData = {
    assigned_to: string
    assigned_to_id: number
    display_id: string
    status: string
    status_color_code: string
    text_color_code: string
    ticket_id: number
    ticket_type: string
    survey_report_url?: any
    data?: any
    solo_logistics_tickets: any
    solo_data?: any
    card_name: string
    main_ticket_dr?: string
    progress: number
}

export type DocHubObj = {
    comment_id?: null
    doc_name: string
    doc_type: string
    file_url: IFile
    is_comment: boolean
    remarks: string
    stage: string
    uploaded_on: string
}

const installationService = api.injectEndpoints({
    endpoints: build => ({
        getInstallationTabs: build.query({
            query: params => ({
                url: `${MODULE_URL}/ticket/total`,
                params: {
                    state_id: JSON.stringify(params.data.stateId ?? []),
                    status_id: JSON.stringify(params.data.statusId ?? []),
                    city_id: JSON.stringify(params.data.cityId ?? []),
                    assigned_to: params.data.assigned_to?.id ?? "",
                    deal_done_by_id: params.data.deal_done_by_id?.id ?? "",
                    age: JSON.stringify(params.data.age ?? []),
                    tag_ids: JSON.stringify(params.data.tags ?? []),
                    age_op: params.data.age_op ?? "",
                    deal_type: params.data.dealType ?? "",
                    raised_on_end: params.data.TicketEndDate ?? "",
                    raised_on_start: params.data.TicketStartDate ?? "",
                    updated_on_start: params.data.UpdateStartDate ?? "",
                    updated_on_end: params.data.UpdateEndDate ?? "",
                    charger_type: JSON.stringify(params.data.chargerIds ?? []),
                    vendor_ids: JSON.stringify(params.data.vendor_ids ?? []),
                    search_key: params.data.search_key ?? "",
                    raised_by_id: params.data.raised_by_id?.id ?? "",
                    blocked_on: JSON.stringify(params.data.blocked_on ?? []),
                    read_filter: params.data.ReadUnread ?? "all",
                    per_page: params?.selectedValue,
                    page: params?.page,
                    site_ids: JSON.stringify(params.data.siteIds ?? []),
                    blocked_reason_id: JSON.stringify(params.data.blocked_reason_id ?? []),
                },
            }),
            transformResponse: (response: { message: StatusTabsData[] }) => response.message,
            providesTags: ["Installation"],
        }),
        getInstallationData: build.query<TicketDataResponseType, { data: any; selectedValue: number; page: number }>({
            query: params => ({
                url: `${MODULE_URL}/ticket/${params.data.parent_status ?? "all_tab"}`,
                params: {
                    state_id: JSON.stringify(params.data.stateId ?? []),
                    status_id: JSON.stringify(params.data.statusId ?? []),
                    city_id: JSON.stringify(params.data.cityId ?? []),
                    assigned_to: params.data.assigned_to?.id ?? "",
                    deal_done_by_id: params.data.deal_done_by_id?.id ?? "",
                    age: JSON.stringify(params.data.age ?? []),
                    age_op: params.data.age_op ?? "",
                    deal_type: params.data.dealType ?? "",
                    raised_on_end: params.data.TicketEndDate ?? "",
                    raised_on_start: params.data.TicketStartDate ?? "",
                    updated_on_start: params.data.UpdateStartDate ?? "",
                    tag_ids: JSON.stringify(params.data.tags ?? []),
                    updated_on_end: params.data.UpdateEndDate ?? "",
                    charger_type: JSON.stringify(params.data.chargerIds ?? []),
                    vendor_ids: JSON.stringify(params.data.vendor_ids ?? []),
                    search_key: params.data.search_key ?? "",
                    raised_by_id: params.data.raised_by_id?.id ?? "",
                    blocked_on: JSON.stringify(params.data.blocked_on ?? []),
                    read_filter: params.data.ReadUnread ?? "all",
                    per_page: params?.selectedValue,
                    page: params?.page,
                    site_ids: JSON.stringify(params.data.siteIds ?? []),
                    blocked_reason_id: JSON.stringify(params.data.blocked_reason_id ?? []),
                },
            }),
            providesTags: ["Installation"],
        }),
        getRaisedByUsers: build.query<{ id: number; name: string }[], void>({
            query: () => ({
                url: `${MODULE_URL}/raised_by_users`,
            }),
            providesTags: ["Installation"],
        }),
        getInstallationDealDetails: build.query<any, { ticket_id: string }>({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL}/ops_ticket_detail`,
                params: {
                    ticket_id,
                },
            }),
            providesTags: (result, error, arg) => ["Installation", { type: "Installation", id: arg.ticket_id }],
        }),
        getInstallationOtherDetails: build.query<
            { cards: CardData[]; images: { images: any[] }; delivery_request: any; reverse_delivery_request: any; project_id: any },
            { ticket_id: string }
        >({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL}/other_details`,
                params: {
                    ticket_id,
                },
            }),
            providesTags: (result, error, arg) => ["Installation", { type: "Installation", id: arg.ticket_id }],
        }),
        getOpsButtonDropdown: build.query<StatusButton[], { ticket_id: string; sub_module: string; role_id: string }>({
            query: params => ({
                url: `${MODULE_URL}/button_dropdown`,
                params,
            }),
            providesTags: ["Installation", "EvApplication"],
        }),
        getOpsCompletionDate: build.query<OpsCompletionDateObj[], { ticket_id: string, module_id: number, submodule_id: number }>({
            query: params => ({
                url: `${MODULE_URL}/completion_date`,
                params,
            }),
            providesTags: ["Installation", "EvApplication"],
        }),
        getOpsCost: build.query<any, { ticket_id: string }>({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL}/costs`,
                params: {
                    ticket_id,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Installation", id: arg.ticket_id }],
        }),
        // For dochub
        getDocHubCategories: build.query<{ id: number; name: string }[], void>({
            query: () => ({
                url: `dochub_category`,
            }),
            transformResponse: (response: IResponse<{ id: number; name: string }[]>) => response.data,
        }),
        getOpsTicketStage: build.query<{ id: number; status: string }[], void>({
            query: () => ({
                url: `${MODULE_URL}/ticket_stage`,
            }),
            transformResponse: (response: IResponse<{ id: number; status: string }[]>) => response.data,
        }),
        getDochubData: build.query<DocHubObj[], { ticket_id: number; ticket_stage: string; doc_type: string }>({
            query: params => ({
                url: `${MODULE_URL}/dochub`,
                params,
            }),
            transformResponse: (response: IResponse<DocHubObj[]>) => response.data,
            providesTags: ["Installation"],
        }),
        getLinkSurveyList: build.query<IResponse<{ id: number; name: string }[]>, void>({
            query: () => ({
                url: `${MODULE_URL}/survey/link_survey`,
            }),
            providesTags: (result, error, arg) => ["Installation"],
        }),
        downloadInstallationTickets: build.query<any, { data: any; selectedValue: number; page: number }>({
            query: (params) => ({
                url: `${MODULE_URL}/list_download/${params.data.parent_status ?? "all_tab"}`,
                params: {
                    state_id: JSON.stringify(params.data.stateId ?? []),
                    status_id: JSON.stringify(params.data.statusId ?? []),
                    city_id: JSON.stringify(params.data.cityId ?? []),
                    assigned_to: params.data.assigned_to?.id ?? "",
                    deal_done_by_id: params.data.deal_done_by_id?.id ?? "",
                    age: JSON.stringify(params.data.age ?? []),
                    age_op: params.data.age_op ?? "",
                    deal_type: params.data.dealType ?? "",
                    raised_on_end: params.data.TicketEndDate ?? "",
                    raised_on_start: params.data.TicketStartDate ?? "",
                    updated_on_start: params.data.UpdateStartDate ?? "",
                    tag_ids: JSON.stringify(params.data.tags ?? []),
                    updated_on_end: params.data.UpdateEndDate ?? "",
                    charger_type: JSON.stringify(params.data.chargerIds ?? []),
                    vendor_ids: JSON.stringify(params.data.vendor_ids ?? []),
                    search_key: params.data.search_key ?? "",
                    raised_by_id: params.data.raised_by_id?.id ?? "",
                    blocked_on: JSON.stringify(params.data.blocked_on ?? []),
                    read_filter: params.data.ReadUnread ?? "all",
                    per_page: params?.selectedValue,
                    page: params?.page,
                    site_ids: JSON.stringify(params.data.siteIds ?? []),
                },
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.link ? "Data Downloaded" : data?.msg }))
                } catch (error: any) { }
            },
            keepUnusedDataFor: 0,
        }),
        // Mutations
        addDocHubData: build.mutation<IResponse<string>, FormData>({
            query: body => ({
                url: `${MODULE_URL}/dochub`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Installation"],
        }),

        addSiteSurveyCompletionDate: build.mutation<IResponse<string>, FormData>({
            query: body => ({
                url: `${MODULE_URL}/delivery_date`,
                method: "POST",
                body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.data }))
                    if(arg.get("source") === "projects") {
                        dispatch(getTicketDetails(arg.get("project_id") as string))
                    }
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Installation", id: arg.get("ticket_id") as string },
                "Installation",
                "Projects",
            ],
        }),

        siteReadyForDispatch: build.mutation<IResponse<string>, FormData>({
            query: body => ({
                url: `${MODULE_URL}/site_ready_for_dispatch`,
                method: "PUT",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data.data }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Installation", id: arg.get("ticket_id") as string },
                "Installation",
            ],
        }),

        requestSiteSurvey: build.mutation<IResponse<[string]>, FormData>({
            query: body => ({
                url: `${MODULE_URL}/survey/request_survey`,
                method: "POST",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data.data[0] }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Installation", id: arg.get("ops_ticket_id") as string },
                "Installation",
                "Projects",
            ],
        }),

        editOpsCompletionDate: build.mutation<{ msg: string }, FormData>({
            query: body => ({
                url: `${MODULE_URL}/completion_date`,
                method: "PUT",
                body: body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled, getState }) => {
                try {
                    const { data } = await queryFulfilled
                    const state: any = getState()
                    const { DemolitionFormValue, page: demoPage, selectedValue: demoSelectedValue } = state.operation
                    dispatch(setAlertFunc({ type: "success", msg: data?.msg }))
                    arg.get("submodule_id") === '21' &&
                        dispatch(
                            getDemolitionTabs({ data: DemolitionFormValue, page: demoPage, selectedValue: demoSelectedValue })
                        )
                    arg.get("submodule_id") === '21' && dispatch(
                        getDemolition({ data: DemolitionFormValue, page: demoPage, selectedValue: demoSelectedValue })
                    )
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Installation", id: arg.get("ticket_id") as string }, "Installation", "EvApplication"],
        }),

        editOpsTicketDetails: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `${MODULE_URL}/ticket`,
                method: "PUT",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Installation", id: arg.get("ticket_id") as string },
                "Installation",
            ],
        }),

        addDRDetails: build.mutation<any, FormData>({
            query: body => ({
                url: `${MODULE_URL}/upload_dr_v2`,
                method: "POST",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        setAlertFunc({
                            type: "success",
                            msg: typeof data?.data === "string" ? data.data : data.message,
                        })
                    )
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.error?.data?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Installation", id: arg.get("ticket_id") as string },
                "Installation",
            ],
        }),
        updateRMCost: build.mutation<IResponse<string>, { ticket_id: number | string; rm_cost: number }>({
            query: body => ({
                url: `${MODULE_URL}/ops_ticket_detail`,
                method: "PUT",
                body: body,
            }),
            invalidatesTags: (result, error, args) => [
                { type: "Installation", id: args.ticket_id as string },
                "Installation",
            ],
        }),
        editOpsVendor: build.mutation<IResponse<string>, FormData>({
            query: body => ({
                url: `${MODULE_URL}/edit_vendor`,
                method: "PUT",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: "Vendor updated successfully" }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, args) => [
                { type: "Installation", id: args.get("ticket_id") as string },
                "Installation",
            ],
        }),
        editLinkSiteSurvey: build.mutation({
            query: body => ({
                url: `${MODULE_URL}/survey/link_survey`,
                method: "PUT",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Installation", id: arg.get("ticket_id") as string },
                "Installation",
            ],
        }),
    }),
})

export const {
    useLazyGetInstallationTabsQuery,
    useLazyGetInstallationDataQuery,
    useGetRaisedByUsersQuery,
    useGetInstallationDealDetailsQuery,
    useGetInstallationOtherDetailsQuery,
    useGetOpsButtonDropdownQuery,
    useGetOpsCompletionDateQuery,
    useGetOpsCostQuery,
    useGetDocHubCategoriesQuery,
    useGetOpsTicketStageQuery,
    useGetDochubDataQuery,
    useGetLinkSurveyListQuery,
    useLazyDownloadInstallationTicketsQuery,

    // Mutations
    useAddDocHubDataMutation,
    useAddSiteSurveyCompletionDateMutation,
    useSiteReadyForDispatchMutation,
    useEditOpsCompletionDateMutation,
    useEditOpsTicketDetailsMutation,
    useEditLinkSiteSurveyMutation,
    useRequestSiteSurveyMutation,
    useAddDRDetailsMutation,
    useUpdateRMCostMutation,
    useEditOpsVendorMutation,
} = installationService

export { installationService }
